'use strict';

/**
 * @function
 * @description remove the parameter and its value from the given url and returns the changed url
 * @param {String} url the url from which the parameter will be removed
 * @param {String} name the name of parameter that will be removed from url
 */
const removeParamFromURL = (url, name) => {
    if (url.indexOf('?') === -1 || url.indexOf(name + '=') === -1) {
        return url;
    }
    let hash;
    const domain = url.split('?')[0];
    let paramUrl = url.split('?')[1];
    const newParams = [];
    // if there is a hash at the end, store the hash
    if (paramUrl.indexOf('#') > -1) {
        hash = paramUrl.split('#')[1] || '';
        paramUrl = paramUrl.split('#')[0];
    }
    const params = paramUrl.split('&');
    for (let i = 0; i < params.length; i++) {
        // put back param to newParams array if it is not the one to be removed
        if (params[i].split('=')[0] !== name) {
            newParams.push(params[i]);
        }
    }
    return domain + '?' + newParams.join('&') + (hash ? '#' + hash : '');
};

module.exports = removeParamFromURL;
